<template>
  <div
    class="too-long-message-tolltip-container"
    :class="{ 'pulse-tooltip': pulseTooltip }"
  >
    <p>
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: 'TooLongMessageTooltip',
  props: {
    pulseTooltip: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const tooltipHeight = this.$el.offsetHeight;
    this.$el.style.top = `-${tooltipHeight + 6}px`;
  },
  methods: {},
};
</script>